import { OnEvent, Service } from '@toeverything/infra';
import { throttle } from 'lodash-es';
import type { Transaction } from 'yjs';

import type { Doc } from '../doc';
import { DocInitialized } from '../doc/events';
import type { DocCreationLocationService } from './service';

@OnEvent(DocInitialized, t => t.onDocInitialized)
export class DocLocationUpdateService extends Service {
  constructor(private readonly location: DocCreationLocationService) {
    super();
  }

  onDocInitialized(doc: Doc) {
    let pending = false;
    const capture = throttle(
      () => {
        if (pending) return;
        pending = true;
        this.location
          .captureForDocs(doc.workspace, [doc.id], undefined, 'update')
          .catch(() => {})
          .finally(() => {
            pending = false;
          });
      },
      30_000,
      { trailing: false }
    );
    const onTransaction = (transaction: Transaction) => {
      if (
        transaction.local &&
        // BlockSuite edits have an origin; untracked initialization/repair
        // transactions must not attach the reader's current location.
        transaction.origin !== null &&
        transaction.changed.size &&
        this.location.enabled &&
        !doc.record.trash$.value &&
        !doc.record.getProperties().createdLocation
      )
        capture();
    };
    doc.yDoc.on('afterTransaction', onTransaction);
    this.disposables.push(() => {
      doc.yDoc.off('afterTransaction', onTransaction);
      capture.cancel();
    });
  }
}
